import axios from 'axios'

const baseURL = window.apiConfig[process.env.NODE_ENV].server

// 创建axios 实例
const service = axios.create({
  baseURL: baseURL // url = base url + request url 配置baseURL
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 0 // request timeout 超时时间
})

export default service
